export default __webpack_public_path__ + "static/media/sacrificial_fragments.4dd54e2d.png";